export const BOTPRESS_ACTIONS = {
  SIGN_IN: "signIn",
  CREATE_ACCOUNT: "createAccount",
  SHOW_CALENDLY: "showCalendly",
} as const;

export const CALENDLY_HOSTNAME = "calendly.com";

export const BOTPRESS_FAB_ROOT_SELECTOR = "#fab-root";

export const ALLOWED_BOTPRESS_ROUTE_NAMES = [
  "home",
  "sign-in",
  "change-password",
  "results",
  "programs-results-view",
  "internship-postings-results-views",
  "courses-results-view",
  "internship-product-page-view",
  "housing-product-page-view",
  "course-product-page-view",
  "program-detail-view",
  "new-application",
  "create-account",
  "experiences",
  "modify-application",
] as const;

export const ATLO_URL_FLAG = {
  PARAM: "atlo",
  VALUE: "true",
} as const;

export const BOTPRESS_CLIENT_EVENTS = {
  CONVERSATION_START: "conversationStart",
} as const;
